/**
 * Plain text for TTS — strip markdown so the model isn’t read as asterisks/backticks.
 */
export function stripMarkdownForSpeech(text: string): string {
  let t = text.trim();
  if (!t) return '';
  t = t.replace(/```[\s\S]*?```/g, ' ');
  t = t.replace(/`([^`]+)`/g, '$1');
  t = t.replace(/\[([^\]]+)\]\([^)]+\)/g, '$1');
  t = t.replace(/^\s*[-*+]\s+/gm, '');
  t = t.replace(/^\s*\d+\.\s+/gm, '');
  t = t.replace(/\*\*([^*]+)\*\*/g, '$1');
  t = t.replace(/\*([^*]+)\*/g, '$1');
  t = t.replace(/_{1,2}([^_\s][^_]*)_{1,2}/g, '$1');
  t = t.replace(/#{1,6}\s?/g, '');
  t = t.replace(/\s+/g, ' ');
  return t.trim();
}

/**
 * Pull the next speakable slice from plain text for incremental TTS (sentence or long clause).
 * `from` is an offset into `plain` (same space as `stripMarkdownForSpeech` output).
 */
export function extractNextSpeakableSegment(
  plain: string,
  from: number
): { segment: string; newOffset: number } | null {
  const rest = plain.slice(from);
  const trimmed = rest.trimStart();
  if (!trimmed) return null;
  const leadWs = rest.length - rest.trimStart().length;

  /** ASCII + common CJK / full-width sentence ends (slightly longer chunks = fewer TTS round-trips). */
  const sentenceRe = /^([\s\S]{12,}?[.!?。．！？])(\s+|$)/u;
  const m = trimmed.match(sentenceRe);
  if (m && m[1].trim().length >= 12) {
    const consumed = leadWs + m[0].length;
    return { segment: m[1].trim(), newOffset: from + consumed };
  }
  /** Long clause without clear punctuation (avoid waiting forever) */
  if (trimmed.length >= 320) {
    const cut = trimmed.lastIndexOf(' ', 320);
    if (cut >= 60) {
      const segment = trimmed.slice(0, cut).trim();
      if (segment.length >= 60) {
        return { segment, newOffset: from + leadWs + cut + 1 };
      }
    }
  }
  return null;
}
